export const USER_ID_STORAGE_NAME = 'user_id';
export const USER_NAME_STORAGE_NAME = 'name';
export const IS_ADMIN_STORAGE_NAME = 'is_admin';
